import { render, staticRenderFns } from "./ViewPreRequestReadOnly.vue?vue&type=template&id=531178ee&"
import script from "./ViewPreRequestReadOnly.vue?vue&type=script&lang=js&"
export * from "./ViewPreRequestReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports